// Function to detect the operating system - for auto opening download section
export function detectOS(userAgent) {
  const osMap = [
    { key: 'windows', osName: 'windows' },
    { key: 'macintosh', osName: 'macos' },
    { key: 'linux x86_64', osName: 'linux' },
    { key: 'linux a', osName: 'linux' },
    { key: 'cros', osName: 'chromebook' },
    { key: 'iphone', osName: 'ios iphone' },
    { key: 'ipad', osName: 'ios ipad' },
    { key: 'android', osName: 'android' },
  ];

  const userAgentLowerCase = userAgent.toLowerCase();
  const detectedOS = osMap.find(({ key }) => userAgentLowerCase.includes(key))?.osName || 'unknown';

  return detectedOS;
}

// Function to detect the platform - for autodownload function
export function detectPlatform(userAgent) {
  const platformMap = [
    { key: 'windows', platform: 'windows' },
    { key: 'macintosh', platform: 'mac' },
    { key: 'linux x86_64', platform: 'linux' },
    { key: 'linux a', platform: 'linux' },
    { key: 'cros', platform: 'chromebook' },
    { key: 'iphone', platform: 'iphone' },
    { key: 'ipad', platform: 'ipad' },
    { key: 'silk', platform: 'amazon' },
    { key: 'android', platform: 'android' },
  ];

  const userAgentLowerCase = userAgent.toLowerCase();
  const detectedPlatform = platformMap.find(({ key }) => userAgentLowerCase.includes(key))?.platform || 'unknown';

  return detectedPlatform;
}

// Function to detect browser
export function detectBrowser(userAgent) {
  const browserMap = [
    { key: 'firefox', browserName: 'Firefox' },
    { key: 'edg', browserName: 'Edge' },
    { key: 'opr', browserName: 'Opera' },
    { key: 'chrome', browserName: 'Chrome', excludeKey: 'edg' }, // Exclude Edge explicitly
    { key: 'safari', browserName: 'Safari' }
  ];

  const userAgentLowerCase = userAgent.toLowerCase();
  const detectedBrowser = browserMap.find(({ key, excludeKey }) => userAgentLowerCase.includes(key) && (!excludeKey || !userAgentLowerCase.includes(excludeKey)))?.browserName || 'unknown';

  return detectedBrowser;
}
